import React from "react";
import "./StickyElement.css";

const StickyElement = () => {
  return (
    <div className="container mt-6">
        <div className="row">
            <div className="col-lg-6">
                <div className="card">
                    <div className="card-header">
                        <h3>Title Top Sticky</h3>
                    </div>
                    <div className="card-block">
                        <div className="sticky-element custom-scroll">
                            <div className="section">
                                <div className="section-header-top mb-2 header-1 p-3">
                                    <h5 className="mb-0 text-white">Section 1</h5>
                                </div>
                                <div className="section-content">
                                    {[...Array(7)].map((_, i) => (
                                        <p key={i}>Content for Section 1</p>
                                    ))}
                                </div>
                            </div>

                            <div className="section">
                                <div className="section-header-top mb-2 header-2 p-3">
                                    <h5 className="mb-0 text-white">Section 2</h5>
                                </div>
                                <div className="section-content">
                                    {[...Array(10)].map((_, i) => (
                                        <p key={i}>Content for Section 2</p>
                                    ))}
                                </div>
                            </div>

                            <div className="section">
                                <div className="section-header-top mb-2 header-3 p-3">
                                    <h5 className="mb-0 text-white">Section 3</h5>
                                </div>
                                <div className="section-content">
                                    {[...Array(10)].map((_, i) => (
                                        <p key={i}>Content for Section 3</p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-6">
                <div className="card">
                    <div className="card-header">
                        <h3>Title Bottom Sticky</h3>
                    </div>
                    <div className="card-block">
                        <div className="sticky-element custom-scroll">
                            <div className="section">
                                <div className="section-content">
                                {[...Array(20)].map((_, i) => (
                                    <p key={i}>Content for Section 1</p>
                                ))}
                                </div>
                                <div className="section-header-bottom header-1 mb-2 p-3">
                                    <h5 className="mb-0 text-white">Section 1</h5>
                                </div>
                            </div>

                            <div className="section">
                                <div className="section-content">
                                {[...Array(20)].map((_, i) => (
                                    <p key={i}>Content for Section 2</p>
                                ))}
                                </div>
                                <div className="section-header-bottom header-2 mb-2 p-3">
                                    <h5 className="mb-0 text-white">Section 2</h5>
                                </div>
                            </div>

                            <div className="section">
                                <div className="section-content">
                                {[...Array(20)].map((_, i) => (
                                    <p key={i}>Content for Section 3</p>
                                ))}
                                </div>
                                <div className="section-header-bottom header-3 mb-2 p-3">
                                    <h5 className="mb-0 text-white">Section 3</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default StickyElement;
